import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import LoadingSpinner from '../../partials/LoadingSpinner';

import ThresholdLine from './ThresholdLine';

import { updateSelectedItems, searchProducts, resetProducts } from '../../../redux/actions/products';
import { getCategories } from '../../../redux/actions/categories';
import { createThresholds, reset } from '../../../redux/actions/thresholds';

const ThresholdSearch = ({ payload, addThresholds, isSearching, searchedProducts, searchedProductsPagination, searchedVariations, selectedProductList, categories, submitSearch, loadCategories, setSelectedProductList, resetProductSearch, thresholds, resetThresholds }) => {
  const [submitted, setSubmitted] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [inStockFilter, setInStockFilter] = useState(false);
  const [purchasingDisabledFilter, setPurchasingDisabledFilter] = useState(false);
  const [categoryFilter, setCategoryFilter] = useState();
  const [showFilters, setShowFilters] = useState(false);

  const [thresholdValues, setThresholdValues] = useState({
    'targetInventory': { 'product': {}, 'variation': {} },
    'lowInventory': { 'product': {}, 'variation': {} },
    'criticalInventory': { 'product': {}, 'variation': {} }
  })

  const [enqueueSearch, setEnqueueSearch] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    resetProductSearch();
    resetThresholds();
    loadCategories(payload);
    setThresholdValues({
      'targetInventory': { 'product': {}, 'variation': {} },
      'lowInventory': { 'product': {}, 'variation': {} },
      'criticalInventory': { 'product': {}, 'variation': {} }
    });
    setSelectedProductList({ variations: {}, products: {} });
  }, []);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if(searchTerm !== ''){
        setCurrentPage(1);
        handleSearch(searchTerm, 1);
      }
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [searchTerm, 500]);

  const handleSearch = (searchTerm, page) => {
    if(!isSearching) {
      setEnqueueSearch(null);
      submitSearch(payload, searchTerm, inStockFilter, categoryFilter);
    } else {
      setEnqueueSearch(searchTerm);
    }
  }
  
  useEffect(() => {
    if(!isSearching) {
      readySearch();
    }
  }, [isSearching]);

  const readySearch = () => {
    if(enqueueSearch) {
      submitSearch(payload, enqueueSearch, inStockFilter, categoryFilter);
      setEnqueueSearch(null);
    }
  }
  
  const toggleInStockFilter = () => {
    setInStockFilter(!inStockFilter);
  }

  const togglePurchasingDisabledFilter = () => {
    setPurchasingDisabledFilter(!purchasingDisabledFilter);
  }

  useEffect(() => {
    handleSearch(searchTerm);
  }, [inStockFilter]);

  useEffect(() => {
    handleSearch(searchTerm);
  }, [categoryFilter]);

  // const switchCategoryFilter = (event, setter) => {
  //   let categoryId = event.hash;
  //   setter(categoryId);
  // }

  const switchCategoryFilter = (event) => {
    setCategoryFilter(event.target.value);
  }

  const setProductResultPage = (page) => {
    setCurrentPage(page);
    handleSearch(searchTerm, page);
  }

  const clearCategory = () => {
    setCategoryFilter(null);
  }

  const validateTerm = (event) => {
    let value = event.target.value;

    setSearchTerm(value);

    if (value) {
      event.target.parentElement.classList.add("field--filled");
    } else {
      event.target.parentElement.classList.remove("field--filled");
    }
  }

  const setTargetInventory = (itemId, type, event) => {
    let assignValues = {...thresholdValues};
    assignValues.targetInventory[type][itemId] = event.target.value;
    setThresholdValues(assignValues);
  }

  const setLowInventory = (itemId, type, event) => {
    let assignValues = {...thresholdValues};
    assignValues.lowInventory[type][itemId] = event.target.value;
    setThresholdValues(assignValues);
  }

  const setCriticalInventory = (itemId, type, event) => {
    let assignValues = {...thresholdValues};
    assignValues.criticalInventory[type][itemId] = event.target.value;
    setThresholdValues(assignValues);
  }

  const validatePage = (event) => {
    let page = event.target.value;

    if (page < 1) {
      page = 1;
    }

    if (page > searchedProductsPagination.total_pages) {
      page = searchedProductsPagination.total_pages;
    }

    setCurrentPage(page);
  }

  const submitPage = () => {
    handleSearch(searchTerm, currentPage);
  }

  const handleSubmit = () => {
    setSubmitted(true);
    addThresholds(payload, selectedProductList, thresholdValues);
  }

  const toggleFilters = (event) => {
    if(showFilters) {
      setShowFilters(false);
      event.target.parentElement.classList.remove("collapsible--opened");
    } else {
      setShowFilters(true);
      event.target.parentElement.classList.add("collapsible--opened");
    }
  }

  const focus = (event) => {
    event.target.parentElement.classList.add("field--focus");
  }

  const blur = (event) => {
    event.target.parentElement.classList.remove("field--focus");
  }

  const deselectAllSelected = () => {
    setSelectedProductList({ variations: {}, products: {} });
  }

  const selectAllSearched = () => {
    let productSection = selectedProductList.products;
    let variationsSection = selectedProductList.variations;

    searchedProducts.forEach((product) => {
      let productInList = Object.keys(productSection).indexOf(String(product.id)) > -1;
      if (!productInList && product.combinations.length === 0) {

        if(product.quantity > 0 || !inStockFilter) {
          productSection[String(product.id)] = {
            productId: product.id,
            smallThumbnailUrl: product.smallThumbnailUrl,
            options: false,
            name: product.name
          }
        }

      }

      product?.combinations?.forEach((combination) => {
        let combinationInList = Object.keys(variationsSection).indexOf(String(combination.id)) > -1;
        if (!combinationInList) {

          if(((combination.quantity || product.quantity) > 0) || !inStockFilter) {
            variationsSection[String(combination.id)] = {
              productId: product.id,
              smallThumbnailUrl: combination.smallThumbnailUrl || product.smallThumbnailUrl,
              options: combination.options,
              name: product.name
            }
          }

        }
      })
    })

    setSelectedProductList({ ...selectedProductList });
  }


  return(
    <>
      <div className="a-card a-card--compact">
        <div className="a-card__paddings">
          <div className="iconable-block iconable-block--hide-in-mobile">
            <div className="iconable-block__infographics">
              <span className="iconable-block__icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path fill-rule="evenodd" clip-rule="evenodd" d="M18 7c0 3.866-3.134 7-7 7-1.5724 0-3.0236-.5184-4.1922-1.3936l-4.1007 4.1007c-.3905.3905-1.0237.3905-1.4142 0-.3905-.3906-.3905-1.0237 0-1.4143l4.1007-4.1007C4.5184 10.0236 4 8.5723 4 7c0-3.866 3.134-7 7-7s7 3.134 7 7zm-2 0c0 2.7614-2.2386 5-5 5S6 9.7614 6 7s2.2386-5 5-5 5 2.2386 5 5z"/></svg>
              </span>
            </div>
            <div className="iconable-block__content">
              <div className="status-block">
                <div className="status-block__central">
                  <div className="status-block__header">
                    <span className="status-block__title">
                      Catalog Search
                      { isSearching && 
                        <div className="left-15 canonical-status text-default canonical-status--info canonical-status--loading canonical-status--has-icon canonical-status--prepend-icon">
                          <div className="canonical-status__icon">
                            <svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" width="28" height="28">
                              <path d="M14,27C6.83,27,1,21.17,1,14c0-1.56,0.27-3.08,0.81-4.52C2.1,8.7,2.96,8.31,3.74,8.59c0.78,0.29,1.17,1.15,0.88,1.93 C4.21,11.63,4,12.8,4,14c0,5.51,4.49,10,10,10c5.51,0,10-4.49,10-10c0-5.51-4.49-10-10-10c-0.83,0-1.5-0.67-1.5-1.5S13.17,1,14,1 c7.17,0,13,5.83,13,13C27,21.17,21.17,27,14,27z"></path>
                            </svg>
                          </div>
                        </div>
                      }
                    </span>
                    <span className="status-block__edit">Edit</span>
                  </div>
                  <div className="status-block__content">
                    <div className="fieldset full-width">
                      <div className="field field--medium">
                        <span className="fieldset__svg-icon"></span>
                        <label className="field__label">Search</label>
                        <input type="text" value={searchTerm} onFocus={focus} onBlur={blur} onChange={validateTerm} className="field__input" tabindex="4" maxlength="64" />
                        <div className="field__placeholder">Search</div>
                        <span className="field-state--success"></span>
                        <span className="field-state--close"></span>
                      </div>
                      <div className="field__error" aria-hidden="true" style={{display: 'none'}}></div>

                      <div class="collapsible top-15 padding-15 a-card__darken search-filters" onClick={(e) => toggleFilters(e)}>
                        <div class="collapsible__header">Search filters</div>
                        <div class="collapsible__body">

                          <div className="flex-container">
                            <div className="element flex-1">
                              <div className="element__title">
                                In Stock
                              </div>
                              <label className="checkbox tiny">
                                { inStockFilter && <input type="checkbox" checked="true" onClick={() => toggleInStockFilter()}/>}
                                { !inStockFilter && <input type="checkbox" onClick={() => toggleInStockFilter()}/>}
                                <div><div></div></div>
                              </label>
                            </div>

                            <div className="flex-1">
                              { !categories.isFetching && categories.status === "success" &&
                                <>
                                  <div className="fieldset fieldset--select">
                                    <div className="field field--medium field--filled">
                                      <label className="field__label">Category</label>
                                      <select value={categoryFilter} id="categoryFilter" onChange={(e) => switchCategoryFilter(e)} className="field__select">
                                        <option hidden disabled selected value></option>
                                        { Object.entries(categories.categories).map(([key, name]) =>
                                          <option value={key}>{name}</option>
                                        )}
                                      </select>

                                      <div className="field__placeholder">Category</div>
                                    </div>
                                  </div>
                                  <button className="left-15 bottom-5 btn btn-link btn-medium" onClick={() => clearCategory()}>
                                    Clear Category
                                  </button>
                                </>
                              }
                              { categories.isFetching &&
                                <LoadingSpinner statusText="Loading categories" />
                              }
                            </div>
                          </div>

                        </div>
                      </div>

                      { searchedProducts && searchedProducts.length > 0 &&
                        <button className="top-5 btn btn-primary-accent btn-medium" onClick={() => selectAllSearched()}>Select All Searched Items</button>
                      }
                      { (!searchedProducts || searchedProducts.length === 0) &&
                        <button className="top-5 btn btn-primary-accent btn-medium" disabled>Select All Searched Items</button>
                      }

                      { (Object.keys(selectedProductList.products).length + Object.keys(selectedProductList.variations).length ) > 0 &&
                        <button className="top-5 left-15 btn btn-primary-accent btn-medium" onClick={() => deselectAllSelected()}>Deselect All Selected Items</button>
                      }
                      { (Object.keys(selectedProductList.products).length + Object.keys(selectedProductList.variations).length ) === 0 &&
                        <button className="top-5 left-15 btn btn-primary-accent btn-medium" disabled>Deselect All Selected Items</button>
                      }

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>



      <div>
        { !isSearching && searchedProducts === null && searchTerm === '' &&
          <div class="a-card a-card--info a-card--info-blue">
            <div className="a-card__paddings">
              <h4>Search Results</h4>
              <p>
                Search your store's catalog above to see live results here
              </p>
            </div>
          </div>
        }

        { isSearching && <LoadingSpinner size="small" statusText="Searching products" /> }

        { !isSearching && searchedProducts !== null && 
        <>
          <button
            className={`btn btn-primary btn-medium ${ submitted ? 'btn-loading' : '' }`}
            onClick={() => handleSubmit()}
            disabled={ submitted || ((Object.keys(selectedProductList.products).length + Object.keys(selectedProductList.variations).length) === 0) }
            isLoading={ submitted }
          >
            Submit New Product Inventory Thresholds
          </button>
          
          <div>
            {/*{ searchedProductsPagination.total_pages > 1 &&
              <div className="flex-container">
                <div className="flex-1">
                  <Pagination
                    currentPage={searchedProductsPagination.current_page}
                    itemsPerPage={50}
                    itemsPerPageOptions={[]}
                    onItemsPerPageChange={null}
                    onPageChange={(newPage) => setProductResultPage(newPage)}
                    totalItems={searchedProductsPagination.total}
                  />
                </div>
                <div className="flex-1">
                  <div className="flex-container">
                    <div className="flex-1">
                      <div className="right-15">
                        <input
                          required
                          onChange={validatePage}
                          placeholder="Page"
                          value={currentPage}
                          type="number"
                          disabled={submitted}
                        />
                      </div>
                    </div>

                    <div className="flex-8">
                      <Text as="span">
                        of {searchedProductsPagination.total_pages} pages &nbsp;
                      </p>

                      <button className="left-15" onClick={() => submitPage()} disabled={submitted}>Set Page</button>
                    </div>
                  </div>
                </div>
              </div>
            }*/}
            { searchedProducts?.map(product =>
              <>
                { product.combinations.length === 0 &&
                  <ThresholdLine
                    payload={payload}
                    type={'product'}
                    productId={product.id}
                    itemId={product.id}
                    options={false}
                    name={product.name}
                    quantity={product.quantity}
                    price={product.price}
                    smallThumbnailUrl={product.smallThumbnailUrl}
                    rowId={product.id}
                    targetInventory={thresholdValues.targetInventory.product[product.id]}
                    setTargetInventory={setTargetInventory}
                    lowInventory={thresholdValues.lowInventory.product[product.id]}
                    setLowInventory={setLowInventory}
                    setCriticalInventory={setCriticalInventory}
                    criticalInventory={thresholdValues.criticalInventory.product[product.id]}
                    submitted={submitted}
                    inStockFilter={inStockFilter}
                  />
                }
                { product?.combinations?.map(combination =>
                  <ThresholdLine
                    payload={payload}
                    type={'variation'}
                    productId={product.id}
                    itemId={combination.id}
                    name={product.name}
                    quantity={combination.quantity || product.quantity}
                    price={combination.price || combination.defaultDisplayedPrice || product.price}
                    smallThumbnailUrl={combination.smallThumbnailUrl || product.smallThumbnailUrl}
                    options={combination.options}
                    targetInventory={thresholdValues.targetInventory.variation[combination.id]}
                    setTargetInventory={setTargetInventory}
                    lowInventory={thresholdValues.lowInventory.variation[combination.id]}
                    setLowInventory={setLowInventory}
                    setCriticalInventory={setCriticalInventory}
                    criticalInventory={thresholdValues.criticalInventory.variation[combination.id]}
                    submitted={submitted}
                    inStockFilter={inStockFilter}
                  />
                )}
              </>
            )}

          </div>
        </>
      }
      </div>
    </>
  )
}

const mapStateToProps = state => ({
  isSearching: state.products.isFetching,
  searchedProducts: state.products.searchedProducts,
  searchedProductsPagination: state.products.searchedProductsPagination,
  searchedVariations: state.products.searchedVariations,
  selectedProductList: state.products.selectedProductList,
  categories: state.categories,
  thresholds: state.thresholds,
});

const mapDispatchToProps = (dispatch) => ({
  submitSearch: (payload, searchTerm, inStockFilter, categoryFilter) => dispatch(searchProducts(payload, searchTerm, inStockFilter, categoryFilter)),
  loadCategories: (payload) => dispatch(getCategories(payload)),
  setSelectedProductList: (items) => dispatch(updateSelectedItems(items)),

  addThresholds: (payload, locationId, thresholds, thresholdValues) => dispatch(createThresholds(payload, locationId, thresholds, thresholdValues)),
  resetThresholds: () => dispatch(reset()),
  resetProductSearch: () => dispatch(resetProducts()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ThresholdSearch);
